<template>
    <div>
        <div class="d-flex justify-content-between align-items-center row">
            <div class="col-sm-12 col-md-3">
                <label for="">Type de Souscription</label>
                <select @change="changeSubscription()" id="subscriptionValue" class="form-control">
                    <option value="1">Toutes</option>
                    <option value="2">Assurance Auto</option>
                    <option value="3">Assurance MRH</option>
                    <option value="4">Assurance Voyage</option>
                </select>
            </div>
            <div class="col-sm-12 col-md-3">
                <label for="">Date de debut</label>
                <input type="date" v-model="tableData.date_debut" id="dt_debut" class="form-control">
                <div v-if="errors.date_debut" style="color: red">
                      {{ errors.date_debut[0] }}
                </div>
            </div>
            <div class="col-sm-12 col-md-3">
                <label for="">Date de fin</label>
                <input type="date" v-model="tableData.date_fin" id="dt_fin" class="form-control">
                <div v-if="errors.date_fin" style="color: red">
                      {{ errors.date_fin[0] }}
                </div>
            </div>
            <div class="col-sm-12 col-md-3 mt-3 mb-2 d-flex justify-content-around">
                <button @click="filtrerData()" class="btn btn-primary">
                    Filtrer
                </button>
                <button @click="exportData()" class="btn btn-primary" id="export_btn" :class="exporting || prospects.length === 0 ? 'disabled' : ''">
                    <span v-if="exporting" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Exporter
                </button>
            </div>
        </div>

        <div class="d-flex justify-content-between align-items-center row">
            <div class="col-sm-12 col-md-1">
                <select style="width:60px !important" class="form-control" v-model="tableData.length" @change="changePerPage()">
                    <option v-for="(records, index) in perPage" :key="index" :value="records">{{records}}</option>
                </select>
            </div>
            <div class="mb-2 col-md-3 text-right">
                <input class="form-control" type="text" v-model="tableData.search"
                   @input="getSearch()">
            </div>
        </div>
        <v-table :columns="columns" :sortKey="sortKey" :sortOrders="sortOrders" @sort="sortBy">
            <tbody>
                <tr class="pointer" @click="showDetail(prospect.id)" v-for="prospect in prospects" :key="prospect.id">
                    <td>{{prospect.id}}</td>
                    <td>{{prospect.name}}</td>
                    <td>{{prospect.product}}</td>
                    <td>{{$format(prospect.amount)}}</td>
                    <td>{{prospect.treat_name }}</td>
                    <td>{{prospect.created_at }}</td>
                    <td>
                        <span v-if="prospect.status === 'add'" class="badge badge-pill badge-info">Paiement à la livraison</span>
                        <span v-if="prospect.status === 'negotiated' && prospect.amount_negotiated !== null" class="badge badge-pill badge-info">Négocié</span>
                        <span v-if="prospect.status === 'paid'" class="badge badge-pill badge-success">Payé</span>
                        <span v-if="prospect.status === 'negotiated' && prospect.amount_negotiated === null" class="badge badge-pill badge-info">En négociation</span>
                        <span v-if="prospect.status === 'save'" style="color: #0b2e13" class="badge badge-pill badge-light">Sauvegardé</span>
                    </td>
                </tr>
            </tbody>
        </v-table>
        <v-paginate :links="links" :navigationFunction="navigation"/>
    </div>
</template>

<script>
import {api, _buildQuery } from "../../../../helpers/shared";
import vTable from '../../../../components/vTable/vTable.vue';
import vPaginate from '../../../../components/vTable/vPaginate1.vue'
import axios from 'axios';
import  debounce  from 'lodash/debounce'
export default {
    components:{
        vTable, vPaginate
    },
    props: ['content','content2'],
    /* mounted(){
        this.getProspects()
    }, */
    data() {
      
        let sortOrders = {};
        let columns = [
            {width: '33%', label: 'id',           name: 'reference' },
            {width: '33%', label: 'client',       name: 'name'},
            {width: '33%', label: 'produit',      name: 'product'},
            {width: '33%', label: 'montant(Fcfa)',name: 'amount'},
            {width: '33%', label: 'traité par',   name: 'treat_name'},
            {width: '33%', label: 'date',         name: 'created_at'},
            {width: '33%', label: 'statut',       name: 'status'}
        ];
        return {
            links: [],
            exporting: false,
            prospects: [],
            columns: columns,
            sortKey: '',
            sortOrders: sortOrders,
            perPage: ['10', '20', '30'],
            tableData: {
                page: 0,
                length: 10,
                search: '',
                column: 0,
                dir: 'desc',
                state: 'all',
                date_debut:'',
                date_fin:'', 
            },
            errors: [],
        }
    },
    mounted() {
            this.getProperSubscription()

    },
    methods: {
        showDetail(uuid){
            this.$router('/administration/prospects/'+uuid+'.content')
        },
        getWithProduct(val){
            this.tableData.product = val;
            this.changePerPage();
        },
        changePerPage(url = 'administration/proper_subscription'){
            this.tableData.page = 1;
            axios.get(api(url), {params: this.tableData})
            .then(response => {
                let content = response.data;
                this.prospects = content.data;
                this.configPagination(content);
            })
            .catch(errors => {
                console.log(errors);
            });
        },
        getNext(url){
            this.tableData.page ++;
            axios.get(url, {params: this.tableData})
            .then(response => {
                let content = response.data;
                this.prospects = content.data;
                this.configPagination(content);
            })
            .catch(errors => {
                console.log(errors);
            });
        },
        getPrev(url){
            this.tableData.page --;
            axios.get(url, {params: this.tableData})
            .then(response => {
                let content = response.data;
                this.prospects = content.data;
                this.configPagination(content);
            })
            .catch(errors => {
                console.log(errors);
            });
        },
        getProspects(url = 'administration/prospects') {
            this.tableData.page++;
            axios.get(api(url), {params: this.tableData})
                .then(response => {
                    let content = response.data;
                    this.prospects = content.data;
                    this.configPagination(content);
                })
                .catch(errors => {
                    console.log(errors);
                });
        },
        configPagination(data) {
            this.links = data.links;
        },
        sortBy(key) {
            this.sortKey = key;
            this.sortOrders[key] = this.sortOrders[key] * -1;
            this.tableData.column = this.getIndex(this.columns, 'name', key);
            this.tableData.dir = this.sortOrders[key] === 1 ? 'asc' : 'desc';
            this.getProspects();
        },
        getIndex(array, key, value) {
            return array.findIndex(i => i[key] == value)
        },
        getSearch: debounce(function (e) {
            this.changePerPage()
        }, 500),

        changeSubscription(){
            let sv = document.querySelector('#subscriptionValue')
            if(sv.value == 1){
                this.tableData.state ="all"
                this.getProperSubscription()
            } else if(sv.value == 2){
                this.tableData.state ="auto"
                this.getProperSubscription()
            } else if(sv.value == 3) {
                this.tableData.state ="mrh"
                this.getProperSubscription()
            } else if (sv.value == 4) {
                this.tableData.state ="travel"
                this.getProperSubscription()
            } else {
                this.tableData.state ="all"
                this.getProperSubscription()
            }
        },
        exportData(){
            this.exporting = true;
                axios.get(api('administration/subscription_excel_new'),{params: this.tableData,responseType: 'arraybuffer'}).then((response) => {
                    let data = response.data;
                     var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                        var fileLink = document.createElement('a');
                        fileLink.href = fileURL;
                        fileLink.setAttribute('download', 'subscription_from_vue.xlsx');
                        document.body.appendChild(fileLink);
                        fileLink.click();  
                    this.exporting = false;
                }).catch((error) => {
                    this.exporting = false;
                    if (error.response.status !== 422){
                        this.$toasted.global.error({message: "Votre connexion a expiré"})
                    }
                    else this.$toasted.global.error({message: "Une erreur est survenu lors de l'exportation"})
                })
        },
        getProperSubscription(url = 'administration/proper_subscription') {
            axios.get(api(url), {params: this.tableData})
                .then(response => {
                    let content = response.data;
                    this.prospects = content.data;
                    this.configPagination(content);
                })
                .catch(errors => {
                    console.log(errors);
                });
        },
        filtrerData(){
                axios.get(api('administration/verify_subscription_excel_dates'),{params: this.tableData}).then((response) => {
                    let content = response.data;
                    this.prospects = content.data;
                    this.configPagination(content);
                    this.errors = [];
                }).catch((error) => {
                    if (error.response.status !== 422){
                        this.$toasted.global.error({message: "Votre connexion a expiré"})
                    }else if(error.response.status === 422){
                        this.errors = error.response.data.errors;
                    }
                    else this.$toasted.global.error({message: "Une erreur est survenu lors de l'exportation"})
                })
        },
        navigation(page) {
                this.tableData.page = page;
                axios.get(api('administration/prospects'), {params: this.tableData})
                    .then(response => {
                        let content = response.data;
                        this.prospects = content.data;
                        this.configPagination(content);
                    })
                    .catch(errors => {
                        console.log(errors);
                    });
        },
  
    },
    
}
</script>

<style lang="scss" scoped>
    .pointer{
        cursor: pointer;
    }
</style>
